<div class="bg-white p-6 rounded-lg mb-6">
  <h2 class="text-2xl font-bold mb-4">Work Order - {{ mode | titlecase }} Mode</h2>

  <form [formGroup]="workOrderForm" (ngSubmit)="onSubmit()" class="space-y-6">

    <!-- Client Info -->
    <mat-card>
      <mat-card-title>Client Info</mat-card-title>
      <mat-divider></mat-divider>
      <div formGroupName="client" class="grid grid-cols-12   gap-4 p-4">
        <div class="col-span-6">
          <mat-label>Client Name</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="name">
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>Address</mat-label>

          <mat-form-field appearance="outline">
            <textarea matInput formControlName="address"></textarea>
          </mat-form-field>
        </div>
      </div>
    </mat-card>

    <!-- Vendor Info -->
    <mat-card>
      <mat-card-title>Vendor Info</mat-card-title>
      <mat-divider></mat-divider>
      <div formGroupName="vendor" class="grid grid-cols-12   gap-4 p-4">
        <div class="col-span-6">
          <mat-label>Name</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="name">
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>Address</mat-label>

          <mat-form-field appearance="outline">
            <textarea matInput formControlName="address"></textarea>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>GSTIN</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="gstin">
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>PAN</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="pan">
          </mat-form-field>
        </div>

      </div>
    </mat-card>

    <!-- Items Table -->
    <mat-card>
      <mat-card-title>Items</mat-card-title>
      <mat-divider></mat-divider>
      <div formArrayName="items" class="space-y-4 p-4">
        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="grid grid-cols-12 gap-4 p-4">
          <div class="col-span-2">
            <mat-label>Code</mat-label>

            <mat-form-field appearance="outline">
              <input matInput formControlName="code">
            </mat-form-field>
          </div>
          <div class="col-span-2">
            <mat-label>Description</mat-label>

            <mat-form-field appearance="outline">
              <input matInput formControlName="description">
            </mat-form-field>
          </div>
          <div class="col-span-2">
            <mat-label>Qty</mat-label>

            <mat-form-field appearance="outline">
              <input matInput type="number" formControlName="quantity">
            </mat-form-field>
          </div>
          <div class="col-span-2">
            <mat-label>Unit Price</mat-label>

            <mat-form-field appearance="outline">
              <input matInput type="number" formControlName="unitPrice">
            </mat-form-field>
          </div>
          <div class="col-span-2">
            <mat-label>Amount</mat-label>

            <mat-form-field appearance="outline">
              <input matInput [value]="item.get('amount')?.value" disabled>
            </mat-form-field>
          </div>
          <div class="col-span-2">
            <mat-label></mat-label><br>

            <button mat-icon-button color="warn" (click)="removeItem(i)" type="button">
              <mat-icon>delete</mat-icon>
            </button>
          </div>






        </div>
        <button mat-raised-button color="primary" type="button" (click)="addItem()">Add Item</button>
      </div>
    </mat-card>

    <!-- Summary -->
    <mat-card>
      <mat-card-title>Summary</mat-card-title>
      <mat-divider></mat-divider>
      <div formGroupName="summary" class="grid grid-cols-12 gap-4 p-4">
        <div class="col-span-4">
          <mat-label>Sub Total</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="subTotal">
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label>CGST (%)</mat-label>


          <mat-form-field appearance="outline">
            <input matInput formControlName="cgst">
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label>SGST (%)</mat-label>

          <mat-form-field appearance="outline">

            <input matInput formControlName="sgst">
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label>IGST (%)</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="igst">
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label>Total</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="total">
          </mat-form-field>
        </div>
      </div>
    </mat-card>

    <!-- Submit -->
    <div class="text-right">
      <button mat-raised-button color="accent" type="submit">Submit</button>
    </div>
  </form>
</div>